import React, { Fragment } from 'react';
import { Card, Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCode, faHandshake, faHeart } from "@fortawesome/free-solid-svg-icons";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";

const WorkSummary = () => {
    return (
        <div>
            <Container fluid={true} className="SummaryBanner pb-3" style={{ background: "#202e5e", border: "1px solid #f32a74" }}>
                <Container className="text-center text-white">
                    <Row>
                        <Col lg={8} md={6} sm={12}>
                            <h2 className="page-title text-left my-5">Works Summary</h2>
                            <Row className="countSection workMain mt-5">

                                <Col>

                                    <FontAwesomeIcon className="icon" icon={faHandshake} />
                                    <h1 className="countNumber">
                                        <CountUp start={0} end={8}>
                                            {({ countUpRef, start }) => (
                                                <VisibilitySensor onChange={start} delayedCall>
                                                    <span ref={countUpRef} />
                                                </VisibilitySensor>
                                            )}
                                        </CountUp>
                                    </h1>
                                    <h4 className="countTitle">Total Projects</h4>
                                    <hr className="bg-white w-25" />
                                </Col>
                                <Col>
                                    <FontAwesomeIcon className="icon" icon={faHeart} />
                                    <h1 className="countNumber">
                                        <CountUp start={0} end={2}>
                                            {({ countUpRef, start }) => (
                                                <VisibilitySensor onChange={start} delayedCall>
                                                    <span ref={countUpRef} />
                                                </VisibilitySensor>
                                            )}
                                        </CountUp>
                                    </h1>
                                    <h4 className="countTitle">Total Clients</h4>
                                    <hr className="bg-white w-25" />
                                </Col>
                                <Col>
                                    <FontAwesomeIcon className="icon" icon={faCode} />
                                    <h1 className="countNumber">
                                        <CountUp start={0} end={10000}>
                                            {({ countUpRef, start }) => (
                                                <VisibilitySensor onChange={start} delayedCall>
                                                    <span ref={countUpRef} />
                                                </VisibilitySensor>
                                            )}
                                        </CountUp>
                                    </h1>
                                    <h4 className="countTitle">Lines Of Codes</h4>
                                    <hr className="bg-white w-25" />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={4} md={6} sm={12}>
                            <Card className="workCard text-dark">
                                <Card.Body>
                                    <Card.Title className="cardTitle text-justify">How i Work</Card.Title>
                                    <div>
                                        <p className="cardSubTitle text-justify"><FontAwesomeIcon className="iconBullet" icon={faCheckCircle} /> Requirement Gathering </p>
                                        <p className="cardSubTitle text-justify"><FontAwesomeIcon className="iconBullet" icon={faCheckCircle} /> System Analysis </p>
                                        <p className="cardSubTitle text-justify"><FontAwesomeIcon className="iconBullet" icon={faCheckCircle} /> Coding Testing</p>
                                        <p className="cardSubTitle text-justify"><FontAwesomeIcon className="iconBullet" icon={faCheckCircle} /> Implementation</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    );
};

export default WorkSummary;